import { Button } from '@mui/material'

import { Icon } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { downloadGeneratedFile } from '@/utils'

import { SemanticSearchSettings } from './NewSemanticQuestion'

const toCSV = (data?: SemanticSearchSettings['questions']) => {
  if (!data) return
  return [
    ['key', 'question', 'answerText', 'source', 'suggestedQuestions'],
    ...data.map(({ key, question, answerText, source, suggestedQuestions }) => [
      key,
      question,
      answerText,
      source,
      (suggestedQuestions || []).join(','),
    ]),
  ]
    .map((v) =>
      v
        .map((x) =>
          Number.isNaN(Number(x)) ? `"${x?.replace(/"/g, '""')}"` : x
        )
        .join(',')
    )
    .join('\n')
}

export const DownloadQuestions = () => {
  const { componentID } = useComponentProvider()
  const current = useGetCustomComponent<SemanticSearchSettings>(componentID)

  const onHandleClick = () => {
    const data = toCSV(current.data?.settings.questions)
    if (!data) return
    downloadGeneratedFile(`${current.data?.name}-questions.csv`, data)
  }
  return (
    <Button startIcon={<Icon name="download" />} onClick={onHandleClick}>
      Download Questions
    </Button>
  )
}
